import { onDocumentReady } from '../utils/events';
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

onDocumentReady(() => {
  const sliderEl = document.querySelector('.values__items');
  if (!sliderEl) return;

  const splide = new Splide(sliderEl, {
    type: 'slide',
    perMove: 1,
    arrows: false,
    pagination: false,
    keyboard: 'global',
    drag: false,
    rewind: false,
    autoWidth: false,
    focus: 0,
    snap: true,
    omitEnd: true,
    trimSpace: 'move',
    breakpoints: {
      768: {
        type: 'loop',
        drag: true,
      },
    },
  });

  splide.mount();

  const track = sliderEl.querySelector('.splide__track');
  const list = sliderEl.querySelector('.splide__list');

  const getItemsCountFromCSS = () => {
    const item = sliderEl.querySelector('.values__item');
    if (!item) return 1;
    const value = getComputedStyle(item)
      .getPropertyValue('--items-count')
      .trim();
    const count = parseInt(value, 10);
    return Number.isNaN(count) ? 1 : count;
  };

  let lastOverflowState = null;

  const updateControlsState = () => {
    const itemsCount = getItemsCountFromCSS();
    const totalSlides = sliderEl.querySelectorAll('.splide__slide').length;
    const isOverflowing =
      totalSlides > itemsCount && list.scrollWidth > track.clientWidth + 20;

    if (lastOverflowState === isOverflowing) return;
    lastOverflowState = isOverflowing;
    const isMobile = window.innerWidth <= 768;

    splide.options = {
      arrows: isOverflowing,
      drag: isMobile,
    };

    if (!isOverflowing) splide.go(0);
  };

  const isItemVisible = (item) => {
    const itemRect = item.getBoundingClientRect();
    const trackRect = track.getBoundingClientRect();
    return (
      itemRect.right > trackRect.left + 10 &&
      itemRect.left < trackRect.right - 10
    );
  };

  const updateVisibleClass = () => {
    sliderEl.querySelectorAll('.values__item').forEach((el) => {
      el.classList.toggle('is-visible', isItemVisible(el));
    });
  };

  const clearStates = () => {
    sliderEl.querySelectorAll('.values__item').forEach((el) => {
      el.classList.remove('is-active', 'is-inactive');
    });
  };

  let isHovered = false;

  sliderEl.addEventListener('mouseenter', () => {
    isHovered = true;
  });

  sliderEl.addEventListener('mousemove', (e) => {
    if (!isHovered) return;

    const item = e.target.closest('.values__item');
    if (!item || !item.classList.contains('is-visible')) return;
    if (item.classList.contains('is-active')) return;

    const visibleItems = Array.from(
      sliderEl.querySelectorAll('.values__item.is-visible')
    );

    clearStates();

    visibleItems.forEach((el) => {
      el.classList.add(el === item ? 'is-active' : 'is-inactive');
    });
  });

  sliderEl.addEventListener('mouseleave', () => {
    isHovered = false;
    clearStates();
  });

  splide.on('moved resized', () => {
    clearStates();
    updateVisibleClass();
  });

  window.addEventListener('resize', () => {
    updateControlsState();
    updateVisibleClass();
  });

  updateControlsState();
  updateVisibleClass();
  clearStates();
});
